import React from "react"
import autobind from "class-autobind"
import { Paper, Tabs, Tab } from "material-ui"
import strings from "../../../localization/strings"
import { IClientDocument, INoteDocument } from "../../../models"
import ClientContacts from "./ClientContacts"
import ClientDetailsPositions from "./ClientDetailsPositions"
import ClientDetailsSchedule from "./ClientDetailsSchedule"
import ClientJobs from "./ClientJobs"
import ClientDetailsShifts from "./ClientDetailsShifts"
import AccountStore from "../../../stores/AccountStore"
import NotesObjectAttributeList from "../../../components/Notes/NotesObjectAttributeList"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"

interface IProps {
    readonly: boolean
    client: IClientDocument
    reloadClient(cb?: Function): void
}
interface IState {
    tabActive: string,
    loadingNotes: boolean,
    notes: INoteDocument[]
}

export default class ClientDetailsData extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            tabActive: "contacts",
            loadingNotes: false,
            notes:[],
        }
        autobind(this)
    }   

    render() {
        return (
            <Paper zDepth={1} style={{ textAlign: "left", margin: 20, marginTop: 20 }}>
                <Tabs
                    value={this.state.tabActive}
                    onChange={tabActive => this.setState({ tabActive })}
                >
                    {/* it's not implemented fully. let's hide for now.
                    {AccountStore.getNoteAttributesEnabled() &&
                        <Tab data-intercom-target={"menu-Client-Attributes"} label={"Attributes"} value="attributes">
                            {this.state.tabActive === "attributes" && this.props.client &&
                                <div className="detail-tab">
                                    <NotesObjectAttributeList 
                                        objectId={this.props.client.Id}
                                    />
                                </div>
                            }
                        </Tab>                  
                    } */}
                    <Tab label={strings.Contacts} value="contacts">
                        {this.state.tabActive === "contacts" &&
                            <ClientContacts
                                readonly={this.props.readonly}
                                clientId={this.props.client.Id}
                                reloadClient={this.props.reloadClient}
                            />
                        }
                    </Tab>
                    <Tab label={strings.Positions} value="positions">
                        {this.state.tabActive === "positions" &&
                            <div className="detail-tab">
                                <ClientDetailsPositions
                                    readonly={this.props.readonly}
                                    clientId={this.props.client.Id}
                                />
                            </div>
                        }
                    </Tab>
                    {AccountStore.getScheduleEnabled() &&
                        <Tab label={strings.Schedule} value="schedule">
                            {this.state.tabActive === "schedule" &&
                                <ClientDetailsSchedule
                                    client={this.props.client}
                                />
                            }
                        </Tab>
                    }
                    {AccountStore.getJobsEnabled() &&
                        <Tab label={checkJobFieldAvailable('plural') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.Jobs} value="jobs">
                            {this.state.tabActive === "jobs" &&
                                <ClientJobs
                                    readonly={this.props.readonly}
                                    client={this.props.client}
                                />
                            }
                        </Tab>
                    }
                    {AccountStore.getScheduleEnabled() &&
                        <Tab label={strings.Shift_Templates} value="shift-templates">
                            {this.state.tabActive === "shift-templates" &&
                                <ClientDetailsShifts
                                    readonly={this.props.readonly}
                                    client={this.props.client}
                                />
                            }
                        </Tab>
                    }
                </Tabs>
            </Paper >
        )
    }
}